import { Component, ViewChild, ElementRef, ChangeDetectionStrategy, Input, Output, EventEmitter, forwardRef, OnChanges } from '@angular/core';
import { WYSIWYG_BUTTONS, FORMAT_OPTIONS, FONTS, FONT_SIZES, COLORS, SIGNATURES } from './wysiwyg-editor.config';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Signature } from '../shared/model/signature';
import { environment } from 'src/environments/environment';
import { AttachmentsService } from '../shared/services/attachments.service';

@Component({
  selector: 'wysiwyg-editor',
  templateUrl: './wysiwyg-editor.component.html',
  styleUrls: ['./wysiwyg-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => WysiwygEditorComponent)
    }
  ]
})
export class WysiwygEditorComponent implements OnChanges {
  @ViewChild('editbox', { static: true }) editbox: ElementRef;
  @Input() signatures: Signature[];
  @Input() message: any;
  @Input() emailId: string;
  @Output() messageChange = new EventEmitter<string>();

  constructor(private attachmentsService: AttachmentsService) {

  }

  private pimaApiSignatureUrl = environment.api + '/lettersignature';

  buttons = WYSIWYG_BUTTONS;
  formatOptions = FORMAT_OPTIONS;
  fonts = FONTS;
  fontSizes = FONT_SIZES;
  colors = COLORS;
  imgTooltip = 'Insert Image'
  customColor = ''

  ngOnChanges() {
    if (this.editbox.nativeElement.innerHTML !== this.message) {
      this.editbox.nativeElement.innerHTML = this.message;
    }
  }

  onMessageChange(event) {
    const val = event.currentTarget.innerHTML;
    this.message = val;
    this.messageChange.emit(val);
  }

  isValidColor(str) {
    return str.match(/^#[a-f0-9]{6}$/i) !== null;
  }

  onCustomColorChange(event) {
    this.customColor = event.target.value;
    if (this.isValidColor(event.target.value)){
    this.colors.push({value: this.customColor, title: this.customColor})
    }
  }

  formatDoc(cmd, val?) {
    if (cmd === 'clean') {
      this.clean();
    }
    if (cmd === 'makehyperlink') {
      this.makeHyperlink();
    }
    if (cmd === 'formatblock' && !val) {
      val = 'blockquote';
    }
    document.execCommand(cmd, false, val);
    this.message = this.editbox.nativeElement.innerHTML;
    this.messageChange.emit(this.editbox.nativeElement.innerHTML);
    this.editbox.nativeElement.focus();
  }

  insertSignature(sig: Signature) {
    // Cannot inline base64 string, violates security policy
    //var image = '<div><img src="data: image/jpeg; base64, ' + encodeURIComponent(sig.img) + '" alt="signature" height="50" /></div>';
    var image = `<div><img style="height: 40px;" src="${this.pimaApiSignatureUrl}/GetId?id=${sig.id}" alt="signature"/></div>`;
    this.editbox.nativeElement.innerHTML += image;
    this.message = this.editbox.nativeElement.innerHTML;
    this.messageChange.emit(this.editbox.nativeElement.innerHTML);
    this.editbox.nativeElement.focus();
    console.log(image);
  }

  onPaste(event: ClipboardEvent) {
    event.preventDefault();

    let clipboardData = event.clipboardData;
    let pastedText = clipboardData.getData('text/plain');

    if (document.queryCommandSupported('insertText')) {
      document.execCommand('insertText', false, pastedText);
    } else {
      document.execCommand('paste', false, pastedText);
    }
  }

  private clean() {
    if (confirm('Are you sure?')) {
      this.editbox.nativeElement.innerHTML = '';
      this.message = '';
      this.messageChange.emit('');
    }
  }

  async insertImage(fileInputEvent: any) {
    var filesSelected = [...fileInputEvent.target.files];
    var editbox = this.editbox;
    var message = this.message;
    var messageChange = this.messageChange;
    if (filesSelected.length > 0) {
      Promise.all(filesSelected.map(async file => {
        if (file.type.match("image.*")) {
          //const key = `${this.emailId}/${file.name}`;
          const key = `uploads/public/${file.name.replace(/ /g,'_')}`;
          const { Id, presignedURL, publicUrl } = await this.attachmentsService.generateS3ImageUploadURL({
            fileName: key,
            contentType: file.type
          });
		  console.log(presignedURL);
          await this.attachmentsService.putImageToS3(file, presignedURL, Id);
          return { file, presignedURL, publicUrl, Id, key };
        }
      })
      ).then(fileArray => {
        fileArray.map(fileResult => {
          console.log(fileResult);
          const { file, presignedURL, publicUrl, Id, key } = fileResult;
          var imageLoaded = document.createElement("img");

          imageLoaded.onload = function () {
            var img: any = this;
            var maxWidth = 600;
            var maxHeight = 600;
            var ratio = 0;
            var width = img.width;
            var height = img.height;

            if (width > maxWidth) {
              ratio = maxWidth / width;
              img.width = maxWidth;
              img.height = height * ratio;
              height = height * ratio;
              width = width * ratio;
            }

            if (height > maxHeight) {
              ratio = maxHeight / height;
              img.height = maxHeight;
              img.width = width * ratio;
              width = width * ratio;
              height = height * ratio;
            }

            editbox.nativeElement.innerHTML += imageLoaded.outerHTML;
            messageChange.emit(editbox.nativeElement.innerHTML);
            editbox.nativeElement.focus();
          };

          imageLoaded.src = publicUrl;

        })
      })

    }
  }

  private makeHyperlink() {
    const url = prompt('Write the URL here', 'https://');
    if (url && url !== '' && url !== 'https://') {
      this.formatDoc('createlink', url);
      this.message = this.editbox.nativeElement.innerHTML;
      this.messageChange.emit(this.editbox.nativeElement.innerHTML);
    }
  }
}
